import { useNavigate, useLocation } from "react-router-dom";
import { Home, Zap, Trophy, User, MessageSquare } from "lucide-react";
import { cn } from "@/lib/utils";
import { prefetchRoute } from "@/components/PrefetchLink";


interface NavItem {
  icon: React.ComponentType<{ className?: string; size?: string | number }>;
  label: string;
  href: string;
}

const navItems: NavItem[] = [
  { icon: Home, label: "Home", href: "/" },
  { icon: Zap, label: "Fin-der", href: "/financial-tinder" },
  { icon: Trophy, label: "League", href: "/financial-league" },
  { icon: MessageSquare, label: "Community", href: "/community" },
  { icon: User, label: "Profile", href: "/dashboard" },
];

const hiddenRoutes = ["/auth", "/install"];

const BottomNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (href: string) => {
    if (href === "/") return location.pathname === "/";
    return location.pathname.startsWith(href);
  };

  const shouldHide = hiddenRoutes.some(r => location.pathname.startsWith(r));
  if (shouldHide) return null;

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-card border-t border-border"
      style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}
    >
      <div className="flex items-center justify-around" style={{ height: 60 }}>
        {navItems.map((item) => {
          const active = isActive(item.href);
          return (
            <button
              key={item.href}
              onClick={() => navigate(item.href)}
              onTouchStart={() => prefetchRoute(item.href)}
              onMouseEnter={() => prefetchRoute(item.href)}
              onFocus={() => prefetchRoute(item.href)}
              className={cn(
                "flex flex-col items-center justify-center flex-1 h-full relative",
                "touch-manipulation focus:outline-none"
              )}
              aria-label={item.label}
              aria-current={active ? "page" : undefined}
            >

              {active && (
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-0.5 rounded-full bg-primary" />
              )}
              <item.icon
                size={22}
                className={cn(
                  "transition-colors",
                  active ? "text-primary" : "text-muted-foreground"
                )}
              />
              {active && (
                <span className="text-[11px] font-medium text-primary mt-0.5 leading-tight">
                  {item.label}
                </span>
              )}
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNavigation;
